<vue-server-messages [messages]="messagesService.messages | async"></vue-server-messages>
<div>
    <div class="col-sm-4">
        <vue-panel [title]="'tabLabel.accountSettingsHeading' | translate: 'PortalBase' | async">
            <mat-nav-list class = "vue-tabs">
                <a mat-list-item
                    [routerLink]="['personalInformation']"
                    routerLinkActive="active"><u>{{ 'label.personalInformation' | translate: 'PortalBase' | async }}</u></a>
                <a mat-list-item
                    [routerLink]="['changePassword']"
                    routerLinkActive="active"><u>{{ 'button.changePassword' | translate: 'PortalBase' | async }}</u></a>
                <a mat-list-item
                    [routerLink]="['securityQuestions']"
                    routerLinkActive="active"><u>{{ 'label.securityQuestions' | translate: 'PortalBase' | async }}</u></a>
            </mat-nav-list>
        </vue-panel>
    </div>
    <div class="col-sm-8">
        <router-outlet></router-outlet>
    </div>
</div>
